import React, { Component } from 'react';
import { UncontrolledCarousel } from 'reactstrap';

export class CarouselDisplay extends Component {
  render() {
    let items = this.props.data.slice(0, 3);

    return (
      <UncontrolledCarousel items={items} className="mb-4" />
    );
  }
}